import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EcoEmail from 'eco-design/elements/eco-email';
import BannerBtn from 'eco-design/sections/eco-banner-card/BannerBtn';
import { emailConfig, shopNowLink } from 'elem/compPage/delta-3-series/config/pageConfig';
import { useEffect } from 'react';
import styles from './index.module.scss';

const BannerSub = () => {
    const { locale } = getLocal();
    const { contactListId, fields } = emailConfig[locale] || emailConfig.us;

    return (
        <EcoEmail
            className="Banner-email"
            contactListId={contactListId}
            defaultTermsCheck
            fields={fields}
            needTerms
            productTitle="Be The First To Know"
            tipsObj={{ placeholder: 'Drop your email.' }}
        />
    );
};

export default function Comp() {
    const { t } = useLang('BannerB');
    const { locale } = getLocal();
    const linkMap = shopNowLink[locale] || shopNowLink.us;
    const list = [
        {
            title: t('Argument1_title'),
            desc: t('Argument1_subtitle'),
        },
        {
            title: t('Argument2_title'),
            desc: t('Argument2_subtitle'),
        },
        {
            title: t('Argument3_title'),
            desc: t('Argument3_subtitle'),
        },
        {
            title: t('Argument4_title'),
            desc: t('Argument4_subtitle'),
        },
    ];
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const width = window.innerWidth;
            let translateY = 192;
            if (width > 1024 && width < 1440) {
                translateY = 128;
            } else if (width >= 768 && width <= 1024) {
                translateY = 103;
            } else if (width < 768) {
                translateY = 58;
            }
            console.log(translateY);
            const sceneA = AniContainer.create({
                asyncFromTo: [
                    // 图一左移
                    [`.${styles.BannerAnimation} .banner-header`, { opacity: 1 }, { opacity: 0 }, 1],
                    [`.${styles.BannerAnimation} .background1`, { opacity: 1 }, { opacity: 0 }, 1],
                    [`.${styles.BannerAnimation} .background2`, { opacity: 0 }, { opacity: 1 }, 1],
                    [`.${styles.BannerAnimation} .product2`, { opacity: 0 }, { opacity: 1 }, 1],
                    [`.${styles.BannerAnimation} .product1`, { opacity: 1 }, { opacity: 0 }, 0.1],
                    // [`.${styles.BannerAnimation} .product1`, { scale: 1 }, { scale: 1.1 }, 1],
                    [`.${styles.BannerAnimation} .product2`, { opacity: 1, scale: 1.8, y: translateY }, { opacity: 1, scale: 2, y: translateY }, 1],
                    // [`.${styles.BannerAnimation} .product1`, { opacity: 1, scale: 1.1 }, { opacity: 0, scale: 1.1 }, 1],
                    [`.${styles.BannerAnimation} .banner-header2`, { opacity: 0 }, { opacity: 1 }, 1],
                    [`.${styles.BannerAnimation} .banner-header2`, { opacity: 1 }, { opacity: 1 }, 1],
                ],
                asyncTimeLine: [0, 1, 1, 1, 1, 1, 1.2, 2],
                triggerElement: `.${styles.BannerAnimation}`,
                triggerHook: 1,
                offset: '20%',
                duration: '110%',
            });
            return () => AniContainer.removeScene(sceneA);
        }
    }, []);
    return (
        <div className={`${styles.BannerAnimation} GtmModuleData-section`} data-section-id="BannerAnimation">
            <div className="product-box">
                <div className="img-box">
                    <div className="secn">
                        <div className="Standard-text">
                            <div className="banner-header">
                                <h1 className="banner-title">{t('BannerB_title')}</h1>
                                <h1 className="banner-desc">{t('BannerB_desc')}</h1>
                                {/* <BannerSub /> */}
                                <div className="banner-btn">
                                    <BannerBtn
                                        lHref={linkMap.nav}
                                        lType="filled"
                                        lRadius="ellipse"
                                        lTheme="black"
                                        dataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'buy',
                                            product_name: t('BannerB_title'),
                                            position: `delta-3-series_Shop Now`,
                                            __btn_id1: `${styles.BannerAnimation} .A1-btn-youtube`,
                                            __btn_id2: 'banner-left',
                                            __btn_type: 'common',
                                        }}
                                        dataBtnId={'banner-left'}
                                        prefixCls={'A1'}
                                        className="GtmModuleData-btn-common"
                                    >
                                        Shop Now
                                    </BannerBtn>
                                    <BannerBtn
                                        prefixCls={'A2'}
                                        lTheme="black"
                                        lType="outlined"
                                        lHref={'https://www.youtube.com/embed/1KMQdlO118E?si=FJC9vhoOab2aHmbw'}
                                        isYouToBe={true}
                                        gtm_title={t('BannerB_title')}
                                        dataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'video',
                                            title_name: t('BannerB_title'),
                                            position: `delta-3-series_${t('BannerB_btn_text')}`,
                                            __btn_id1: `${styles.BannerAnimation} .A2-btn-youtube`,
                                            __btn_id2: 'banner-right',
                                            __btn_type: 'common',
                                        }}
                                        dataBtnId={'banner-right'}
                                        className="GtmModuleData-btn-common"
                                    >
                                        {t('BannerB_btn_text')}
                                    </BannerBtn>
                                </div>
                            </div>
                            <div className="banner-header2">
                                <h1 className="standard-title">{t('Standard_name')}</h1>
                                <ul className="standard-list">
                                    {list.map((item, index) => (
                                        <li key={index} className="standard-items">
                                            <p className="list-title">{item.title}</p>
                                            <p className="list-desc">{item.desc}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="product">
                                <EfImg className="product1" pc="https://websiteoss.ecoflow.com/upload/image/1760167383329/pd1_3x.webp" />
                                <EfImg className="product2" pc="https://websiteoss.ecoflow.com/upload/image/1760167558500/pd2.webp" />
                            </div>
                        </div>
                    </div>
                    <div className="background">
                        <EfImg
                            className="background1"
                            pc="https://websiteoss.ecoflow.com/upload/image/1760095407959/kv.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1760095481077/mobilekv.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1760095481077/mobilekv.jpg"
                        />
                        <EfImg
                            className="background2"
                            pc="https://websiteoss.ecoflow.com/figma-uploads/1758535243080-cyt7dq-compressed-top%20center.jpg"
                            h5="https://websiteoss.ecoflow.com/figma-uploads/1758535222118-2vqhsb-compressed-top%20center.jpg"
                        />
                    </div>
                    {/* <BannerB /> */}
                </div>
            </div>
            {/* <Standard /> */}
        </div>
    );
}
